/* eslint-disable camelcase  */

import {
  Button,
  Card,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import useAxiosWithAuth from '../api/useAxiosWithAuth';
import Page from '../components/Page';

const EmailSchedular = () => {
  const [mailTimes, setMailTimes] = useState(null);
  const [timeList, setTimeList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const { post, get } = useAxiosWithAuth();

  const onSubmit = () => {
    console.log(timeList);
    saveMailTimes(timeList);
  };

  const setMailTime = (time, index) => {
    const newTimeList = [...timeList];
    newTimeList[index] = time;
    setTimeList(newTimeList);
  };

  const saveMailTimes = async (times) => {
    try {
      setIsLoading(true);
      const res = await post(`approval-schedule`, { times });
      // console.log({ payload });
      toast.success('Mail times saved successfully');
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      toast.error("Mail times couldn't be saved");
    } finally {
      getMailtimes();
      setIsLoading(false);
    }
  };

  const getMailtimes = async () => {
    try {
      setIsLoading(true);
      const res = await get(`approval-schedule`);
      console.log(res?.data?.times?.length);
      setMailTimes(res?.data?.times?.length);
      setTimeList(res?.data?.times);
      // console.log({ payload });
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getMailtimes();
  }, []);

  const handleReset = () => {
    setMailTimes(null);
    setTimeList([]);
    saveMailTimes([]);
    handleClose();
  };

  return (
    <Page title="Email Schedular">
      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2} ml={2}>
          <Typography variant="h4" gutterBottom>
            Email Schedular
          </Typography>
        </Stack>

        <Card style={{ padding: '16px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <p>Send E-mails</p>
            <FormControl size="small">
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <InputLabel id="demo-simple-select-label">x times per day</InputLabel>
                <Select
                  // size="small"
                  style={{ minWidth: '200px', paddingTop: '0px' }}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={mailTimes || ''}
                  label="x times per day"
                  onChange={(e) => setMailTimes(e.target.value)}
                >
                  <MenuItem value={1}>Once</MenuItem>
                  <MenuItem value={2}>Twice</MenuItem>
                  <MenuItem value={3}>Three Times</MenuItem>
                  <MenuItem value={4}>Four Times</MenuItem>
                  <MenuItem value={5}>Five Times</MenuItem>
                </Select>
                <p>per day</p>
              </div>
            </FormControl>
          </div>
          <Divider style={{ margin: '16px 0px' }} />

          {mailTimes ? (
            new Array(mailTimes).fill(0).map((item, index) => (
              <div
                key={index}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}
              >
                <p>
                  Set {index === 0 && 'first'} {index === 1 && 'second'} {index === 2 && 'third'}{' '}
                  {index === 3 && 'fourth'} {index === 4 && 'fifth'} email sending time:
                </p>
                <TextField
                  onChange={(e) => setMailTime(e.target.value, index)}
                  type="time"
                  size="small"
                  variant="outlined"
                  value={timeList[index]}
                />
              </div>
            ))
          ) : (
            <h4 style={{ textAlign: 'center' }}>No Data Found!</h4>
          )}
          <Divider style={{ margin: '16px 0px' }} />
          <Stack justifyContent={'end'} direction={'row'} gap={2}>
            {!!mailTimes && (
              <>
                <Button onClick={handleClickOpen} variant="outlined" color="primary">
                  Reset
                </Button>
                <Button onClick={onSubmit} variant="contained" color="primary">
                  Save
                </Button>
              </>
            )}
          </Stack>
        </Card>
      </Container>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Confirm!'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to reset current times?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleReset} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
};

export default EmailSchedular;
